import ConversationList from "@/components/Controls/ConversationList";
import { selectCurrConversation } from "@/features/control/controlSlice";
import { useAppSelector } from "@/hooks/redux";
import clsx from "clsx";

const Control = () => {
  const currConversationIndex = useAppSelector(selectCurrConversation);

  return (
    // Below md the layout is single-pane: the list shows only while no
    // conversation is open; desktop (md+) always shows it.
    <section
      className={clsx(
        "flex-col overflow-y-auto border-r border-neutral-300",
        currConversationIndex !== null ? "hidden md:flex" : "flex"
      )}
    >
      <ConversationList />
    </section>
  );
};

export default Control;
